export default "__VITE_ASSET__DFLa2KWT__"